import { Image } from "react-bootstrap";

const NavImageButton = () => {
    return(
        <div className="ps-5 pe-5">
            <Image width='115' height='57' src={`${process.env.PUBLIC_URL}/portalen192transparent.png`} fluid/>
        </div>
    )
}

export default NavImageButton;